import Upload from '@common/Upload'
import { formatAreaCascader, isSiDaProperty } from '@merchant-backend/util'
import { getChartLength } from '@util'
import cls from 'classnames'
import { Cascader, MagicInput, Select } from 'hljd'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styles from '../../style.module.less'

let imgFilters = {
  mime_types: [{ title: 'Image files', extensions: 'jpg,png,jpeg,bmp' }]
}

const Option = Select.Option

@observer
export default class extends Component {
  //获取地址
  getLocation = (options, values) => {
    let provice = options.find(item => item.value == values[0]) || {}
    let city = provice.children || []
    let area = city.find(item => item.value == values[1]) || {}
    return area.children || []
  }

  getYears = () => {
    const endYear = new Date().getFullYear()
    const results = []
    let startYear = 1950
    while (startYear <= endYear) {
      results.push(startYear)
      startYear++
    }
    return results.sort((a, b) => b - a)
  }

  render() {
    const { store } = this.props
    const {
      phone,
      logo_path_square,
      name,
      working_at,
      position,
      shop_area,
      country,
      contact_mobile,
      des,
      property_id
    } = store

    let style = { marginLeft: 190 }
    let options = formatAreaCascader(country)
    const years = this.getYears()
    const defaultYear = new Date().getFullYear() - 5

    return (
      <div
        className={cls({
          [styles.edit]: true,
          [styles.register_edit]: true
        })}
      >
        <div className={styles.item} style={{ ...style }}>
          <span className={styles.must}>手机号</span>
          <MagicInput
            size="large"
            style={{ width: 460 }}
            placeholder="请输入手机号"
            onChange={e => store.changeField('phone')(e.target.value)}
            value={phone}
            maxLength={11}
            showCount
            countPosition="right"
          />
          <p className={styles.txt}>
            请填写成员接收短信链接，提交认证材料的的手机号
          </p>
        </div>
        <div className={styles.item} style={{ ...style }}>
          <span className={styles.must} style={{ verticalAlign: 165 }}>
            头像
          </span>
          <Upload
            clipabled
            link={logo_path_square ? logo_path_square : ''}
            onOk={store.upload('logo_path_square')}
            onDelete={store.removeImg('logo_path_square')}
            target="_self"
            aspect={400 / 400}
            onCliped={store.clipPic('logo_path_square')}
            filters={imgFilters}
            style={{ height: 200, width: 200 }}
          />
          <div className={styles.logoExample}>
            <p>示例：</p>
            <img src="https://qnm.hunliji.com/o_1dicjvgqm1djv1q1l1qjjl261kcc9.png" />
          </div>
          <p className={styles.txt}>
            头像中不能包含营销信息、联系方式、微信、微博、网址二维码等
          </p>
          <p
            className={styles.txt}
            style={{ color: '#448AFCFF', marginTop: 2 }}
          >
            建议尺寸400*400像素
          </p>
        </div>

        <div className={styles.item} style={{ ...style }}>
          <span className={styles.must}>称呼</span>
          <MagicInput
            size="large"
            placeholder="请输入您的称呼"
            style={{ width: 460 }}
            onChange={e => store.changeField('name')(e.target.value)}
            value={name}
            maxLength={4}
            showCount
            countPosition="right"
            lengthCount={value => getChartLength(value, 'floor')}
          />
          <p className={styles.txt}>
            不支持符号、表情和描述性文字，不超过4个字
          </p>
          <p className={styles.txt} style={{ marginTop: 2 }}>
            无需输入职业，团队名称将在您加入团队后自动添加
          </p>
        </div>

        <div className={styles.item} style={{ ...style }}>
          <span className={styles.must}>入行时间</span>
          <Select
            size="large"
            style={{ width: 460 }}
            value={working_at || undefined}
            onChange={store.changeField('working_at')}
            placeholder="请选择入行时间"
            onDropdownVisibleChange={() => {
              if (!working_at) {
                store.changeField('working_at')(defaultYear)
              }
            }}
          >
            {years.map(item => (
              <Option value={item} key={item}>
                {item} 年
              </Option>
            ))}
          </Select>
        </div>

        <div className={styles.item} style={{ ...style }}>
          <span className={styles.must}>头衔</span>
          <Select
            size="large"
            style={{ width: 460 }}
            value={position || undefined}
            onChange={store.changeField('position')}
            placeholder="请选择职位"
            onDropdownVisibleChange={() => {
              if (!position) {
                store.changeField('position')(2)
              }
            }}
          >
            <Option value={1}>资深</Option>
            <Option value={2}>专家</Option>
            <Option value={3}>总监</Option>
            <Option value={4}>首席</Option>
          </Select>
        </div>

        <div className={styles.item} style={{ ...style }}>
          <span className={styles.must}>联系电话</span>
          <MagicInput
            size="large"
            style={{ width: 460 }}
            placeholder="用于接听客户电话"
            onChange={e => store.changeField('contact_mobile')(e.target.value)}
            value={contact_mobile}
            maxLength={11}
            showCount
            countPosition="right"
          />
        </div>

        <div className={styles.item} style={{ ...style }}>
          <span className={styles.must}>所在地区</span>
          <Cascader
            size="large"
            style={{ width: 460 }}
            options={options}
            value={toJS(shop_area)}
            onChange={store.changeField('shop_area')}
            placeholder="请选择所在地区"
          />
        </div>

        <div className={styles.item} style={{ ...style }}>
          <span className={styles.atwill}>个人简介(可选)</span>
          <MagicInput.TextArea
            autoSize={{ minRows: 6, maxRows: 10 }}
            style={{ width: 460 }}
            placeholder="请填写个人简介"
            onChange={e => store.changeField('des')(e.target.value)}
            value={des}
            maxLength={isSiDaProperty(property_id) ? 100 : 19}
            showCount
            countPosition="inner"
          />
          <>
            <p className={styles.txt}>
              请从从业经历、技术特点等方面介绍自己，不超过100字
            </p>
            <p className={styles.txt} style={{ marginTop: 2 }}>
              请勿包含网址、微信、手机号、支付方式等，以及“最”、“独一无
            </p>
            <p className={styles.txt} style={{ marginTop: 2 }}>
              二”等违反广告法的极限词。
            </p>
          </>
        </div>
      </div>
    )
  }
}
